import { de } from './de';

export const fr: typeof de = {
  language: {
    de: 'Deutsch',
    fr: 'Français',
    it: 'Italiano',
  },
  myApplications: {
    title: 'Mes candidatures',
    archive: 'Archives',
    archiveCount: 'Archives ({{count}})',
    backToList: 'Retour à Mes candidatures',
    archiveIntro:
      'Candidatures terminées et archivées. Les écoles ne voient pas ce que tu archives.',
    filterLabel: 'Filtrer par statut',
    all: 'Toutes',
    listLabel: 'Tes candidatures',
    archiveListLabel: 'Candidatures archivées',
    loadFailed: 'Tes candidatures n’ont pas pu être chargées.',
    retry: 'Réessayer',
    empty: {
      title: 'Pas encore de candidatures',
      text: 'Ici, tu vois où en sont tes candidatures. Rien qui te convient ? Envoie une candidature spontanée à l’école de ton choix.',
      jobs: 'Voir les postes ouverts',
      schools: 'Découvrir les écoles',
      archiveTitle: 'Les archives sont vides',
      archiveText:
        'Les candidatures que tu archives arrivent ici. Les écoles ne voient pas ce que tu archives.',
      filtered: 'Aucune candidature avec ce statut.',
    },
    menu: {
      label: 'Actions pour {{title}}',
      posting: 'Voir l’annonce',
      school: 'Voir le profil de l’école',
      withdraw: 'Retirer la candidature',
      archive: 'Archiver',
      restore: 'Sortir des archives',
    },
    withdraw: {
      title: 'Retirer la candidature ?',
      text: 'Tu retires ta candidature « {{title}} » auprès de {{school}}. L’école voit la candidature avec le statut « Retirée » et ne peut plus la traiter. Cette action est irréversible.',
      confirm: 'Retirer la candidature',
      cancel: 'Annuler',
      done: 'Candidature retirée.',
      failed:
        'La candidature n’a pas pu être retirée. L’école l’a peut-être traitée entre-temps. Recharge la page et réessaie.',
    },
    archived: 'Candidature archivée.',
    restored: 'Candidature de retour dans Mes candidatures.',
    archiveFailed: 'Cela n’a pas fonctionné. Réessaie, s’il te plaît.',
  },
  installHint: {
    close: 'Fermer la remarque',
    install: "Installer l'app",
    applications: {
      title: "Les réponses de l'école directement sur ton téléphone",
      text: "Ajoute Bildigsnetz à ton écran d'accueil. Tu recevras une notification push dès qu'une école répond.",
    },
    home: {
      title: 'Bildigsnetz comme app sur ton téléphone',
      text: "Ajoute Bildigsnetz à ton écran d'accueil. Tu recevras messages et réponses immédiatement par notification push.",
    },
    sheet: {
      title: "Bildigsnetz sur l'écran d'accueil",
      ok: "J'ai compris",
      ios: {
        '1': 'Dans Safari, touche «Partager» en bas.',
        '2': "Choisis «Sur l'écran d'accueil».",
        '3': 'Ouvre Bildigsnetz depuis là et active les notifications push.',
      },
      android: {
        '1': 'Dans le navigateur, touche le menu en haut à droite.',
        '2': "Choisis «Installer l'application» ou «Ajouter à l'écran d'accueil».",
        '3': 'Ouvre Bildigsnetz depuis là et active les notifications push.',
      },
    },
  },
  applicationDetail: {
    head: 'Ta candidature du {{date}}',
    headInitiative: 'Ta candidature spontanée du {{date}}',
    status: 'Statut',
    progress: 'Avancement de ta candidature',
    since: 'depuis le {{date}}',
    pending: 'en attente',
    step: {
      sent: 'Envoyée',
      review: 'En examen',
      interview: 'Entretien',
      decision: 'Décision',
      answer: "Réponse de l'école",
      accepted: 'Acceptée',
      rejected: 'Refusée',
      withdrawn: 'Retirée',
    },
    state: {
      done: '(terminé)',
      now: '(étape actuelle)',
      todo: '(à venir)',
      yes: '(acceptée)',
      no: '(clôturée)',
    },
    text: {
      PENDING:
        "L'école examine ta candidature. Tu recevras un e-mail dès que le statut change.",
      PENDING_INITIATIVE:
        "L'école a reçu ta candidature spontanée et te recontactera.",
      INVITED:
        "L'école aimerait faire ta connaissance. Tu trouveras l'invitation dans le chat et dans tes e-mails.",
      ACCEPTED:
        "Félicitations ! L'école t'a donné une réponse positive. Elle discutera directement avec toi des prochaines étapes. Tu trouveras son message dans le chat et dans tes e-mails.",
      REJECTED:
        "L'école a choisi une autre personne. Tu trouveras son message dans le chat et dans tes e-mails. Bonne chance pour la suite de tes recherches !",
      WITHDRAWN: "Tu as retiré cette candidature. L'école ne la traite plus.",
    },
    withdraw: 'Retirer la candidature',
    withdrawInitiative: 'Retirer la candidature spontanée',
    posting: 'Description du poste',
    schoolProfile: "Profil de l'école",
    authorityProfile: 'Profil de la commune scolaire',
    letter: "Message à l'école",
    letterReviewer: "Message à l'école / lettre de motivation",
    attachments: 'Pièces jointes',
    cv: 'CV',
    tandemCv: '2e CV pour une candidature en tandem',
    qualifications: 'Diplômes et certificats',
    additionalDocs: 'Certificats de travail et autres',
    view: 'Afficher',
  },
  jobArchive: {
    rejectAll: 'Refuser les {{count}} candidatures ouvertes',
    rejectAllHint:
      'Après l’archivage, le refus s’ouvre avec le texte standard. Tu peux l’adapter avant l’envoi.',
    tooMany:
      'Plus de {{max}} candidatures ouvertes : refuse-les dans l’aperçu des candidatures par groupes de {{max}} au maximum.',
  },
  settings: {
    title: 'Paramètres',
    crumb: 'Tes paramètres',
    back: 'Retour',
    save: 'Enregistrer',
    change: 'Modifier',
    next: 'Continuer',
    cancel: 'Annuler',
    failed: 'Une erreur s’est produite. Réessaie plus tard, s’il te plaît.',
    currentPassword: 'Mot de passe actuel',
    forgotPassword: 'Mot de passe oublié ?',
    tile: {
      account: 'Compte utilisateur',
      accountSub: 'Données d’accès et paramètres personnels',
      privacy: 'Confidentialité',
      privacySub: 'Choisis ici quelles informations sont visibles',
      notifications: 'Notifications',
      notificationsSub: 'Notifications par e-mail et suggestions de postes',
      subscription: 'Abonnement',
      subscriptionSub: 'Gère ici les paramètres de ton abonnement',
    },
    account: {
      access: 'Données d’accès',
      contact: 'Coordonnées',
      contactSub: 'Domicile et numéro de téléphone',
      contactSubEmail: 'Domicile, e-mail et numéro de téléphone',
      password: 'Modifier le mot de passe',
      personal: 'Paramètres personnels',
      name: 'Modifier le nom',
      delete: 'Supprimer le profil',
      deleteSub: 'Tu ne veux plus utiliser Bildigsnetz ?',
    },
    name: {
      crumb: 'Nom',
      intro:
        'Tes données personnelles sont la base de ton profil Bildigsnetz. Si tu les modifies ici, nous vérifions les changements et les validons manuellement.',
      info: 'Remarques importantes sur le nom',
      firstName: 'Prénom',
      lastName: 'Nom',
      reason: 'Motif de la modification',
      saved: 'Nom modifié.',
      rulesTitle: 'Deux règles s’appliquent à ton nom :',
      rule1:
        '1. Indique ton prénom et ton nom en entier (p. ex. « Max » / « Meier », pas « M. » / « Meier »).',
      rule2:
        '2. Indique ton vrai nom (pas « Bibi Blocksberg » ou « James Bond »).',
      action: 'Modifier le nom',
    },
    email: {
      title: 'Modifier l’adresse e-mail',
      intro:
        'Ici, tu peux modifier l’adresse e-mail avec laquelle tu te connectes et à laquelle nous t’envoyons les notifications.',
      current: 'Ton adresse e-mail actuelle',
      edulog:
        'Tu te connectes via Edulog. Pour modifier ton adresse e-mail, adresse-toi à notre',
      support: 'support',
      new: 'Nouvelle adresse e-mail',
      invalid: 'Indique une adresse e-mail valide, s’il te plaît.',
      sentTitle: 'Modification de l’adresse e-mail demandée',
      sentText:
        'Nous t’avons envoyé un lien à {{email}}. Clique dessus pour confirmer la nouvelle adresse. Ensuite, tu te connectes avec la nouvelle adresse. D’ici là, ton ancienne adresse reste valable.',
    },
    password: {
      title: 'Modifier le mot de passe',
      intro:
        'Définis ici le nouveau mot de passe avec lequel tu te connectes à Bildigsnetz.',
      saved: 'Mot de passe mis à jour.',
      resetSent: 'Nous t’envoyons un e-mail à ton adresse :',
      resetHint:
        'Clique sur le lien dans l’e-mail pour modifier ton mot de passe.',
    },
    delete: {
      title: 'Supprimer le profil',
      intro:
        'Dommage que tu ne veuilles plus utiliser Bildigsnetz. Tu es une partie importante du système éducatif suisse et nous aimerions te garder. Attention : nous supprimons réellement les données de ton profil. Cette action est irréversible.',
      ownerTitle: 'Transmets d’abord la responsabilité principale',
      ownerText:
        'Tu es propriétaire des organisations suivantes. Pour qu’elles ne restent pas sans personne responsable, transmets la responsabilité principale à un·e autre Super Admin avant de supprimer ton profil.',
      toTeam: 'Vers Équipe & autorisations',
      blocked: 'Suppression impossible',
      deleting: 'Suppression du profil …',
      confirm: 'Nous sommes désolés de te perdre comme membre.',
      deleted: 'Le profil a été supprimé.',
      failed:
        'Le profil n’a pas pu être supprimé. Réessaie plus tard, s’il te plaît.',
    },
    privacy: {
      title: 'Confidentialité',
      analytics: 'Analytics et suivi',
      analyticsText:
        'Ces cookies nous permettent de comprendre comment tu utilises notre site afin de l’améliorer de manière ciblée.',
      saved: 'Confidentialité mise à jour.',
    },
    contact: {
      title: 'Coordonnées',
      email: 'E-mail',
      changeEmail: 'Modifier l’adresse e-mail ?',
      phone: 'Numéro de téléphone',
      saved: 'Coordonnées enregistrées.',
    },
    notifications: {
      title: 'Notifications par e-mail',
      newsletter:
        'J’aimerais recevoir les informations importantes par newsletter',
      chat: 'Notification quand je reçois un message dans le chat',
      alwaysOn: 'Toujours actif',
      saved: 'Paramètres e-mail mis à jour.',
      section: {
        team: 'Profil de l’école & équipe',
        hr: 'Processus RH',
        admin: 'Changements d’administration',
        account: 'Compte',
      },
      item: {
        member_joined: {
          label: 'Nouveau membre de l’équipe',
          description:
            'Quand une personne rejoint ton école ou ta commune scolaire en tant que membre.',
        },
        member_left: {
          label: 'Membre de l’équipe parti',
          description:
            'Quand un membre quitte ton école ou ta commune scolaire.',
        },
        member_removed: {
          label: 'Retiré·e d’une équipe',
          description:
            'Quand une administratrice ou un administrateur te retire d’une équipe.',
        },
        application_received: {
          label: 'Nouvelle candidature',
          description:
            'Quand une nouvelle candidature arrive pour l’un de tes postes.',
        },
        application_withdrawn: {
          label: 'Candidature retirée',
          description:
            'Quand une candidate ou un candidat retire sa candidature.',
        },
        application_confirmation_copy: {
          label: 'Copie de l’accusé de réception',
          description:
            'Une copie de l’accusé de réception envoyé aux candidat·e·s.',
        },
        job_runtime_ending: {
          label: 'Fin de la durée de publication',
          description:
            'Quand la durée de publication d’une annonce arrive bientôt à son terme.',
        },
        admin_added: {
          label: 'Droits d’administration reçus (école)',
          description:
            'Quand tu reçois des droits d’administration pour une école.',
        },
        admin_revoked: {
          label: 'Droits d’administration retirés (école)',
          description:
            'Quand tes droits d’administration pour une école sont retirés.',
        },
        authority_admin_added: {
          label: 'Droits d’administration reçus (commune scolaire)',
          description:
            'Quand tu reçois des droits d’administration pour une commune scolaire.',
        },
        authority_admin_revoked: {
          label: 'Droits d’administration retirés (commune scolaire)',
          description:
            'Quand tes droits d’administration pour une commune scolaire sont retirés.',
        },
        account_deleted: {
          label: 'Compte supprimé',
          description: 'Confirmation quand ton compte a été supprimé.',
        },
      },
    },
    push: {
      title: 'Notifications sur cet appareil',
      intro:
        'Pour les nouveaux messages et les nouvelles candidatures, une notification et un chiffre apparaissent sur l’icône de l’app, même quand Bildigsnetz est fermé.',
      active: 'Actif sur cet appareil',
      off: 'Désactiver',
      enable: 'Activer les notifications',
      needsInstall:
        'Sur iPhone et iPad, les notifications ne fonctionnent que si Bildigsnetz est sur l’écran d’accueil : dans le navigateur, touche l’icône de partage et choisis « Sur l’écran d’accueil ». Ouvre ensuite Bildigsnetz avec la nouvelle icône et active-les ici.',
      denied:
        'Les notifications sont bloquées pour Bildigsnetz. Tu peux les autoriser dans les réglages de ton navigateur ou de ton appareil, puis recharger la page.',
      unavailable: 'Les notifications ne sont pas encore activées.',
      unsupported: 'Ce navigateur ne prend pas en charge les notifications.',
      error: 'Cela n’a pas fonctionné. Réessaie, s’il te plaît.',
      retry: 'Réessayer',
    },
    templates: {
      settings: 'Tes paramètres',
      title: 'Modèles',
      tile: 'Modèles',
      tileSub:
        'Tes textes et les modèles de l’école pour invitations, confirmations et refus',
      tab: {
        PERSONAL: 'Mes modèles',
        SCHOOL: 'Modèles de l’école',
      },
      intro: {
        PERSONAL:
          'Tes textes personnels. Jusqu’à 3 par type, toi seul·e les vois. Tu enregistres de nouveaux modèles directement en écrivant avec «Enregistrer comme modèle».',
        SCHOOL:
          'Textes pour toute l’école. Jusqu’à 3 par type. Toutes les personnes avec droits d’écriture peuvent les utiliser, seuls titulaire, admin et RH peuvent les modifier.',
      },
      org: 'École',
      noOrg:
        'Tu n’appartiens à aucune école. Les modèles de l’école sont réservés au personnel d’une école.',
      count: '{{count}} sur {{max}}',
      empty: {
        PERSONAL:
          'Pas encore de modèle personnel. Écris une {{kind}}, adapte le texte et choisis «Enregistrer comme modèle».',
        SCHOOL:
          'Pas encore de modèle de l’école pour ce type. En écrivant une {{kind}}, enregistre-la avec «Toute l’école».',
      },
      subject: 'Objet',
      savedAt: 'Enregistré le {{date}}',
      name: 'Nom du modèle',
      placeholders:
        'Variables : {vorname}, {nachname}, {stelle}, {absender}, {schule}',
      edit: 'Modifier',
      editLabel: 'Modifier le modèle {{name}}',
      deleteLabel: 'Supprimer le modèle {{name}}',
      save: 'Enregistrer',
      cancel: 'Annuler',
      delete: 'Supprimer',
      deleteTitle: 'Supprimer le modèle «{{name}}» ?',
      deleteText:
        'Le modèle disparaît de «Mes modèles». Les messages déjà envoyés restent inchangés.',
      deleteTextSchool:
        'Le modèle disparaît pour toute l’école. Les messages déjà envoyés restent inchangés.',
      saved: 'Modèle enregistré.',
      deleted: 'Modèle supprimé.',
      forbidden:
        'Seuls titulaire, admin et RH peuvent modifier les modèles de l’école.',
      failed: 'Cela n’a pas fonctionné. Réessaie.',
      loadFailed: 'Les modèles n’ont pas pu être chargés.',
      retry: 'Réessayer',
      footer:
        'Bildigsnetz demande confirmation avant de supprimer. Les modèles standard de Bildigsnetz restent toujours disponibles.',
    },
    language: {
      title: 'Langue',
      hint: 'S’applique à l’app et à tous les e-mails de Bildigsnetz',
      saved: 'Langue enregistrée',
      failed: 'La langue n’a pas pu être enregistrée. Réessaie, s’il te plaît.',
    },
  },
  login: {
    title: 'Bonjour !',
    intro:
      'Avec ton compte, tu accèdes aux profils des professionnel·les et à toutes les possibilités de Bildigsnetz.',
    email: 'E-mail',
    password: 'Mot de passe',
    passwordRequired: 'Saisis ton mot de passe.',
    submit: 'Se connecter',
    edulog: 'Se connecter avec Edulog',
    google: 'Se connecter avec Google',
    noAccount: 'Pas encore de compte ?',
    signup: 'S’inscrire',
    forgotPassword: 'Mot de passe oublié ?',
    error: {
      credentials: 'Ton adresse e-mail ou ton mot de passe est incorrect.',
      tooManyRequests:
        'Trop de tentatives. Attends quelques minutes, puis réessaie.',
      offline: 'Pas de connexion. Vérifie ta connexion Internet et réessaie.',
      server:
        'Tes identifiants sont corrects, mais nous n’avons pas pu charger ton profil. Réessaie dans quelques minutes.',
    },
  },
  authError: {
    otherProvider:
      'Ton compte est déjà lié à un autre mode de connexion (p. ex. Google ou e-mail).',
    emailInUse: 'Cette adresse e-mail est déjà utilisée.',
    invalidEmail: 'L’adresse e-mail n’est pas valide.',
    wrongPassword: 'Le mot de passe est incorrect.',
    tooManyRequests:
      'Trop de tentatives. Attends quelques minutes, puis réessaie.',
    offline: 'Pas de connexion. Vérifie ta connexion Internet et réessaie.',
    userDisabled: 'Ce compte est bloqué. Contacte le support.',
    unknown: 'Une erreur s’est produite.',
  },
  signup: {
    title: 'Inscris-toi gratuitement',
    subtitle: 'Ton profil est créé en une minute.',
    email: 'E-mail',
    emailPlaceholder: 'nom@exemple.ch',
    emailInvalid: 'L’adresse e-mail n’est pas valable.',
    emailRequired: 'L’adresse e-mail est obligatoire.',
    password: 'Mot de passe',
    passwordHelp: 'Qu’est-ce qu’un mot de passe sûr ?',
    passwordHint:
      'Au moins 8 caractères, avec majuscules, minuscules et un chiffre.',
    passwordRequired: 'Saisis un mot de passe.',
    passwordWeak:
      'Le mot de passe est trop faible : au moins 8 caractères, avec majuscules, minuscules et un chiffre.',
    showPassword: 'Afficher le mot de passe',
    hidePassword: 'Masquer le mot de passe',
    newsletter: 'Je souhaite recevoir la newsletter',
    termsBefore: 'En t’inscrivant, tu acceptes les',
    terms: 'CG',
    termsBetween: ', la',
    privacy: 'déclaration de protection des données',
    termsAnd: 'et la',
    cookies: 'politique en matière de cookies',
    termsAfter: '.',
    submit: 'Créer un compte',
    or: 'ou',
    edulog: 'S’inscrire avec Edulog',
    google: 'S’inscrire avec Google',
    haveAccount: 'Tu as déjà un compte ?',
    login: 'Se connecter',
    error: 'Une erreur s’est produite. Réessaie plus tard.',
    benefitsTitle: 'Tes avantages avec un profil',
    benefits: {
      apply: {
        title: 'Postuler en quelques clics',
        text: 'Enregistre tes documents une fois et réutilise-les pour chaque candidature.',
      },
      chat: {
        title: 'Chatter directement',
        text: 'Écris simplement aux écoles et à d’autres professionnel·le·s.',
      },
      push: {
        title: 'Notifications sur ton mobile',
        text: 'Réponses des écoles et nouveaux postes directement sur ton mobile, avec Bildigsnetz sur l’écran d’accueil.',
      },
      searchAgent: {
        title: 'Alerte emploi personnelle',
        text: 'Reçois automatiquement par e-mail les nouveaux postes qui te correspondent.',
      },
      applications: {
        title: 'Gérer tes candidatures',
        text: 'Toutes tes candidatures et leur statut au même endroit.',
      },
      profile: {
        title: 'Profil professionnel',
        text: 'Montre tes points forts et reçois des demandes d’écoles.',
      },
      network: {
        title: 'Réseau',
        text: 'Découvre des professionnel·le·s et trouve des possibilités de visites de classe.',
      },
    },
  },
  receivedApplications: {
    backToJobs: 'Retour aux annonces et candidatures',
    title: 'Aperçu des candidatures',
    tileHint: 'Clique sur un statut pour filtrer',
    filterByStatus: 'Filtrer par statut',
    toolbar: 'Adapter l’affichage',
    search: 'Chercher un nom ou un e-mail',
    status: {
      ALL: 'Toutes',
      PENDING: 'En cours d’examen',
      INVITED: 'Invité·e',
      ACCEPTED: 'Acceptée',
      REJECTED: 'Refusée',
      WITHDRAWN: 'Retirée',
    },
    sort: {
      label: 'Tri',
      NEWEST: 'Réception, plus récentes d’abord',
      OLDEST: 'Réception, plus anciennes d’abord',
      RATING: 'Évaluation',
      NAME: 'Nom de A à Z',
    },
    filter: {
      label: 'Filtres',
      rating: 'Évaluation',
      unrated: 'Pas encore évaluée',
      membership: 'Adhésion',
      MEMBER: 'Membres uniquement',
      GUEST: 'Sans compte',
      period: 'Réception',
      periodALL: 'Toutes les dates',
      period7: '7 derniers jours',
      period30: '30 derniers jours',
      reset: 'Réinitialiser',
      close: 'Terminé',
    },
    view: {
      label: 'Affichage',
      cards: 'Vue en cartes',
      list: 'Vue en liste',
    },
    rating: {
      label: 'Évaluation',
      set: 'Évaluation {{rating}}',
      current: 'Évaluation {{rating}}',
      none: 'Pas encore évaluée',
      change: 'modifier',
      remove: 'Supprimer l’évaluation',
      failed: 'L’évaluation n’a pas pu être enregistrée.',
    },
    selection: {
      label: 'Sélection',
      count: '{{count}} sélectionnée(s)',
      clear: 'Annuler la sélection',
    },
    readOnly: {
      title: 'Tu as un accès en lecture.',
      text: 'Tu vois les candidatures et les évaluations. Seules les personnes avec droits d’écriture peuvent modifier.',
    },
    empty: {
      title: 'Pas encore de candidatures',
      job: 'Dès que quelqu’un postule, la carte apparaît sous «En cours d’examen». Tu reçois un e-mail.',
      initiative: 'Les candidatures sans poste précis apparaissent ici.',
    },
    noMatch: 'Aucune candidature ne correspond à la recherche ou aux filtres.',
    loadFailed: 'Les candidatures n’ont pas pu être chargées.',
    retry: 'Réessayer',
    jobLoadFailed: 'L’annonce n’a pas pu être chargée.',
    showMore: 'Afficher {{count}} de plus',
    conflict:
      'Quelqu’un vient de modifier la candidature. L’aperçu est à jour.',
    changeDenied: 'Tu as seulement un accès en lecture à cette candidature.',
    emptyColumn: 'Aucune candidature',
    dragHint:
      'Glisser une carte dans une autre colonne change seulement le statut, sans message. Sans souris : changer le statut dans le dossier.',
    emptyWithdrawn:
      'Seul·e·s les candidat·e·s peuvent retirer leur candidature.',
    expand: 'Déplier la colonne {{status}} avec {{count}} candidatures',
    collapse: 'Replier la colonne {{status}}',
    select: 'Sélectionner {{name}}',
    selectAll: 'Sélectionner toutes les candidatures {{status}}',
    new: 'Nouveau',
    member: 'Membre',
    guest: 'Pas membre',
    applied: 'Reçue le',
    phone: 'Téléphone',
    mail: 'E-mail',
    mailTo: 'E-mail à {{name}}',
    dossier: {
      back: 'Retour à l’aperçu',
      jobs: 'Annonces & candidatures',
      loading: 'Chargement de la candidature …',
      loadFailed: 'La candidature n’a pas pu être chargée.',
      accessDenied: {
        title: 'Pas d’accès à cette candidature',
        text: 'Ton rôle dans cette école ne permet pas de consulter les candidatures. Adresse-toi au/à la propriétaire ou à un·e admin de l’école.',
      },
      readOnly:
        'Tu vois le dossier et peux télécharger les documents. Seules les personnes avec droits d’écriture peuvent modifier.',
      appliedFor: 'Candidature pour',
      status: 'Statut',
      statusFailed: 'Le statut n’a pas pu être modifié.',
      contact: 'Contact',
      profile: 'Voir le profil',
      guestHint:
        'Candidature sans compte : pas de profil ni de chat. Joignable par e-mail ou téléphone.',
      letterAndDocuments: 'Lettre de motivation et documents',
      downloadAll: 'Télécharger tout le dossier',
      downloading: 'Création du dossier …',
      downloadFailed: 'Le dossier n’a pas pu être téléchargé. Réessaie.',
      zipName: 'Dossier de candidature',
      noLetter: 'Pas de lettre de motivation.',
      documents: 'Documents',
      docs: {
        cv: 'CV',
        tandemCv: 'CV du/de la partenaire de jobsharing',
        diplomas: 'Diplômes et certificats',
        references: 'Certificats de travail et références',
      },
      noFile: 'Aucun fichier',
      download: 'Télécharger {{name}}',
      open: 'Ouvrir {{name}}',
      ratingHint:
        'L’évaluation vaut pour toute l’équipe et n’est visible qu’en interne.',
      notes: {
        title: 'Notes',
        empty: 'Pas encore de notes.',
        add: 'Nouvelle note',
        edit: 'Modifier',
        delete: 'Supprimer',
        save: 'Enregistrer',
        cancel: 'Annuler',
        hint: 'Toutes les personnes autorisées à voir cette candidature voient les notes. La personne candidate ne les voit jamais.',
        failed: 'La note n’a pas pu être enregistrée.',
        deleteTitle: 'Supprimer la note ?',
        deleteText:
          'La note sera supprimée pour tout le monde et ne pourra pas être restaurée.',
        discardTitle: 'Abandonner la note ?',
        discardText: 'Ta note n’est pas encore enregistrée et sera perdue.',
        keepEditing: 'Continuer à modifier',
      },
      messages: {
        loadFailed: 'Les messages n’ont pas pu être chargés.',
        title: 'Messages',
        empty: 'Aucun message envoyé pour l’instant.',
        by: 'par {{name}}',
        retry: 'Renvoyer',
        retried: 'Sera renvoyé.',
        retryFailed: 'Le renvoi a échoué.',
        kind: {
          MESSAGE: 'Message',
          INVITATION: 'Invitation',
          ACCEPTANCE: 'Acceptation',
          REJECTION: 'Refus',
        },
        channel: {
          CHAT: 'Chat',
          EMAIL: 'E-mail',
        },
        state: {
          PENDING: 'en cours d’envoi',
          SENDING: 'en cours d’envoi',
          ACCEPTED: 'envoyé',
          DELIVERED: 'distribué',
          FAILED: 'échec',
          BOUNCED: 'non distribuable',
        },
      },
      history: {
        title: 'Historique',
        someone: 'Quelqu’un',
        submitted: 'Candidature reçue',
        status: '{{name}} a mis le statut sur « {{status}} »',
        rated: '{{name}} a évalué avec {{rating}}',
        unrated: '{{name}} a supprimé l’évaluation',
        viewed: '{{name}} a ouvert la candidature',
        claimed: 'La personne invitée a créé un compte',
      },
    },
    compose: {
      close: 'Fermer',
      cancel: 'Annuler',
      backToMessage: 'Retour au message',
      toOne: 'À {{name}}',
      toMany: 'À {{count}} personnes',
      initiative: 'Candidature spontanée',
      kindLabel: 'Type de message',
      from: 'De',
      via: 'via Bildigsnetz',
      replyTo: 'noreply@bildigsnetz.ch · Les réponses vont à {{email}}',
      copyToMe: 'M’envoyer une copie',
      to: 'À',
      ownMail: 'chaque personne reçoit son propre e-mail',
      channel: {
        label: 'Envoyer via',
        CHAT_AND_EMAIL: 'Chat et e-mail',
        CHAT_AND_EMAIL_sub: 'Message dans le chat, e-mail comme avis',
        EMAIL_ONLY: 'E-mail seulement',
        EMAIL_ONLY_sub: 'Comme pour les personnes sans profil',
        mixed:
          '{{members}} personnes sur {{total}} sont membres. Les autres reçoivent le message uniquement par e-mail.',
      },
      guestOne:
        '{{name}} n’est pas membre de Bildigsnetz et reçoit le message par e-mail.',
      guestMany:
        'Aucune de ces personnes n’est membre de Bildigsnetz. Toutes reçoivent le message par e-mail.',
      languageOther:
        'Modèles standard en {{language}}, la langue de la candidature.',
      languageNames: { de: 'allemand', fr: 'français', it: 'italien' },
      languageMixed:
        'Les candidatures sont dans des langues différentes. Un modèle standard non modifié est envoyé à chaque personne dans sa langue.',
      templates: {
        own: 'Mes modèles',
        school: 'Modèles de l’école',
        standard: 'Modèles standard',
        count: '{{count}} sur 3',
        noneOwn:
          'aucun pour l’instant. Adapte un texte et enregistre-le en bas avec «Enregistrer comme modèle».',
      },
      subject: 'Objet',
      body: 'Message',
      hintOne: 'Modifiable. {schule} est remplacé à l’envoi.',
      hintMany:
        'Modifiable. {vorname} et {nachname} sont remplacés pour chaque personne.',
      statusNote:
        'Après l’envoi, le statut passe à «{{status}}». Rien ne change avant.',
      statusNoteMany:
        'Après l’envoi, le statut des {{count}} personnes passe à «{{status}}». Rien ne change avant.',
      quickNote: 'Envoyé immédiatement. Le statut passe à «{{status}}».',
      sentOne: 'Message envoyé.',
      sentMany: '{{count}} messages envoyés.',
      partial:
        '{{sent}} envoyés. {{failed}} n’ont pas pu être envoyés car ils ont été modifiés entre-temps.',
      failed: 'Le message n’a pas pu être envoyé.',
      templatesFailed: 'Les modèles n’ont pas pu être chargés.',
      unfilled:
        'Le texte contient encore un espace réservé comme [date]. Remplace-le, puis renvoie le message.',
      discard: {
        title: 'Abandonner le message ?',
        text: 'Ton texte n’a pas encore été envoyé et sera perdu.',
        confirm: 'Abandonner',
        cancel: 'Continuer à écrire',
      },
      versionConflict:
        'Quelqu’un a modifié la candidature entre-temps. Ton texte est conservé. Vérifie l’état et renvoie.',
      invalidTransition:
        'Le statut de la candidature ne permet plus ce message. Il n’a pas été envoyé.',
      withdrawn: 'La candidature a été retirée. Le message n’a pas été envoyé.',
      changedMeanwhile:
        'La candidature a été modifiée entre-temps. Le message n’a pas été envoyé.',
      skipped:
        '{{count}} sur {{total}} sont ignorées, car leur statut ne le permet pas, par exemple déjà refusées.',
      notPossible: 'Ce message n’est pas possible au statut « {{status}} ».',
      skippedBadge: 'Ignorée',
      INVITATION: {
        short: 'Invitation',
        plural: 'd’invitation',
        title: 'Écrire une invitation',
        quickTitle: 'Envoyer une invitation',
        send: 'Envoyer l’invitation',
        sendQuick: 'Envoyer l’invitation maintenant',
        sendMany: 'Envoyer {{count}} invitations',
        confirmTitle: 'Envoyer {{count}} invitations ?',
        confirmText:
          'Chacune des {{count}} personnes reçoit son propre message. Le statut passe à «Invité·e». Les e-mails envoyés ne peuvent pas être rappelés.',
      },
      ACCEPTANCE: {
        short: 'Acceptation',
        plural: 'd’acceptation',
        title: 'Écrire une acceptation',
        quickTitle: 'Envoyer une acceptation rapide',
        send: 'Envoyer l’acceptation',
        sendQuick: 'Envoyer l’acceptation maintenant',
        sendMany: 'Envoyer {{count}} acceptations',
        confirmTitle: 'Envoyer {{count}} acceptations ?',
        confirmText:
          'Chacune des {{count}} personnes reçoit son propre message. Le statut passe à «Accepté·e». Les e-mails envoyés ne peuvent pas être rappelés.',
      },
      REJECTION: {
        short: 'Refus',
        plural: 'de refus',
        title: 'Écrire un refus',
        quickTitle: 'Envoyer un refus rapide',
        send: 'Envoyer le refus',
        sendQuick: 'Envoyer le refus maintenant',
        sendMany: 'Envoyer {{count}} refus',
        confirmTitle: 'Envoyer {{count}} refus ?',
        confirmText:
          'Chacune des {{count}} personnes reçoit son propre message. Le statut passe à «Refusé·e». Les e-mails envoyés ne peuvent pas être rappelés.',
      },
      saveTemplate: {
        open: 'Enregistrer comme modèle',
        title: 'Enregistrer comme modèle',
        fullTitle: 'Tu as déjà 3 modèles {{kind}}',
        lead: 'Enregistre le texte pour le réutiliser plus tard.',
        fullLead:
          'Par type, il y a 3 modèles personnels et 3 modèles de l’école. Choisis celui que tu veux remplacer.',
        name: 'Nom du modèle',
        nameHint:
          'Bildigsnetz adapte automatiquement les noms et l’intitulé du poste la prochaine fois.',
        who: 'Qui peut utiliser le modèle ?',
        personal: 'Moi seulement',
        personalSub: 'Apparaît sous «Mes modèles»',
        school: 'Toute l’école',
        schoolSub:
          'Apparaît pour tout le monde sous «Modèles de l’école». Propriétaire, admin et RH seulement',
        replace: 'Quel modèle veux-tu remplacer ?',
        save: 'Enregistrer',
        replaceSave: 'Remplacer et enregistrer',
        saved: 'Modèle enregistré.',
        forbidden:
          'Seuls propriétaire, admin et RH peuvent enregistrer des modèles de l’école.',
        limit: 'Il y a déjà 3 modèles de ce type.',
        failed: 'Le modèle n’a pas pu être enregistré.',
      },
    },
    actions: {
      label: 'Actions',
      menu: 'Actions pour {{name}}',
      invite: 'Inviter',
      inviteSub: 'Entretien, leçon d’essai, journée découverte',
      accept: 'Accepter',
      acceptSub: 'Message personnel',
      quickAccept: 'Acceptation rapide',
      quickSub: 'Texte standard, envoyé immédiatement',
      onlySingle: 'Possible uniquement pour une seule candidature',
      reject: 'Refuser',
      rejectSub: 'Message personnel',
      quickReject: 'Refus rapide',
      tooMany: '50 au maximum à la fois.',
    },
    initiative: {
      title: 'Candidatures spontanées',
      subtitle: 'Candidatures sans poste précis',
      link: 'Candidatures spontanées',
    },
  },
  applyForm: {
    backJob: 'Retour au poste',
    backSchool: 'Retour au profil de l’école',
    forJob: 'Ta candidature pour',
    forInitiative: 'Ta candidature spontanée à',
    badge: {
      fulltime: 'Poste fixe',
      substitute: 'Remplacement',
      temporary: 'Engagement à durée déterminée',
      initiative: 'Candidature spontanée',
    },
    hello: {
      member: 'Bonjour {{name}}, presque terminé',
      memberInitiative: 'Bonjour {{name}}, ravi·e de te voir',
      guest: 'Candidature en tant qu’invité·e',
      guestInitiative: 'Ravi·e de te voir !',
    },
    intro: {
      member:
        'Les données de ton profil sont reprises. Complète ce qui manque et envoie.',
      guest: 'Sans compte, directement à l’école.',
      initiative:
        'Même sans poste mis au concours, l’école se réjouit de faire ta connaissance.',
    },
    progress: '{{done}} étapes sur {{total}} terminées',
    progressLabel: 'Progression de la candidature',
    duration: {
      member: 'Environ 2 minutes',
      guest: 'Environ 4 minutes',
    },
    requiredNote: 'Les champs obligatoires sont marqués d’un *.',
    stepDone: ', étape {{n}} terminée',
    stepOpen: ', étape {{n}} sur {{total}}',
    step: {
      personal: {
        job: 'Données personnelles',
        initiative: 'À propos de toi',
      },
      qualification: {
        job: 'Ta qualification',
        initiative: 'Ta qualification',
      },
      message: {
        job: 'Message à l’école',
        initiative: 'Parle de toi à l’école',
      },
      docs: {
        job: 'Tes documents',
        initiative: 'Tes documents',
      },
      confirm: {
        job: 'Confirmations',
        initiative: 'Confirmations',
      },
    },
    personal: {
      memberNote:
        'Ces données valent uniquement pour cette candidature. Ton profil reste inchangé.',
      profileName: 'Nom de ton profil',
      salutation: 'Civilité',
      birthDate: 'Date de naissance',
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'E-mail',
      phone: 'Téléphone',
      street: 'Rue et n°',
      postalCode: 'NPA',
      city: 'Localité',
    },
    salutation: {
      FEMALE: 'Madame',
      MALE: 'Monsieur',
      NONE: 'Non précisé',
    },
    qualification: {
      help: 'Pour le métier auquel tu postules. L’école peut trier selon ce critère.',
      DIPLOMA: {
        title: 'Diplômé·e',
        text: 'Formation achevée ou diplôme reconnu pour ce métier.',
      },
      BASE_YEAR_COMPLETED: {
        title: 'Année de base réussie',
        text: 'En formation, la première année est réussie.',
      },
      TRAINING: {
        title: 'Début de formation',
        text: 'En formation, la première année est en cours.',
      },
      NON_SPECIALIST: {
        title: 'Sans formation spécifique',
        text: 'Sans formation dans ce métier, par exemple reconversion.',
      },
    },
    message: {
      label: 'Motivation ou lettre de candidature',
      placeholder: 'Chère équipe …',
      help: {
        job: 'Quelques phrases personnelles suffisent, ou colle ta lettre de candidature.',
        initiative:
          'Qu’est-ce qui te motive, qu’apportes-tu ? Quelques phrases suffisent.',
      },
    },
    docs: {
      memberNote:
        'Repris de ton dossier de candidature. Tu peux retirer ou ajouter des fichiers pour cette candidature.',
      cv: 'CV',
      cvUpload: 'Télécharger le CV',
      diplomas: 'Diplômes et certificats',
      tandemCv: '2e CV (uniquement pour une candidature en tandem)',
      tandemCvUpload: 'Télécharger le 2e CV',
      references: 'Certificats de travail et autres',
      filesUpload: 'Télécharger des fichiers',
      formats: 'PDF, DOC ou DOCX, 5 Mo au maximum chacun.',
    },
    confirm: {
      terms:
        'Mes données sont correctes et j’accepte les CG et la déclaration de protection des données.',
      criminalRecord:
        'Je confirme que mon casier judiciaire ne contient aucune condamnation non radiée, qu’aucune procédure pénale n’est en cours contre moi et qu’aucune interdiction formelle ou de fait d’exercer ne me frappe (ni en Suisse ni à l’étranger).',
      required: 'Les deux confirmations sont nécessaires.',
    },
    footNote: {
      member:
        'Tu reçois une confirmation par e-mail. Tu vois l’état sous «Mes candidatures».',
      guest: 'Tu reçois une confirmation par e-mail.',
    },
    cancel: 'Annuler',
    send: 'Envoyer la candidature',
    sendInitiative: 'Envoyer la candidature spontanée',
    failed: {
      alreadyApplied:
        'Tu as déjà postulé à ce poste. Tant que cette candidature est ouverte, une deuxième n’est pas possible.',
      closed: 'Ce poste n’accepte plus de candidatures.',
      notPublished: 'Ce poste n’est plus mis au concours.',
      notYetPublished: 'Ce poste n’est pas encore mis au concours.',
      expired: 'Le délai de candidature pour ce poste est échu.',
      disabled: 'Les candidatures ne sont pas possibles pour le moment.',
      fileUnreadable:
        'Un fichier n’a pas pu être lu. Télécharge-le à nouveau, s’il te plaît.',
      fileNotOwned:
        'Un fichier n’appartient pas à ton compte. Télécharge-le à nouveau, s’il te plaît.',
      offline: 'Pas de connexion. Vérifie ta connexion internet et réessaie.',
      generic: 'Une erreur s’est produite. Réessaie, s’il te plaît.',
    },
    error: {
      salutation: 'Choisis une civilité.',
      birthDate: 'Indique ta date de naissance.',
      birthDateRange: 'Vérifie la date de naissance.',
      firstName: 'Indique ton prénom.',
      lastName: 'Indique ton nom.',
      email: 'Indique ton adresse e-mail.',
      emailFormat:
        'Saisis une adresse e-mail valable, par exemple nom@exemple.ch.',
      phone:
        'Indique ton numéro de téléphone pour que l’école puisse te joindre.',
      street: 'Indique la rue et le numéro.',
      postalCode: 'Indique le NPA.',
      city: 'Indique la localité.',
      qualification: 'Choisis où tu en es dans ton métier.',
      message: 'Écris quelques phrases à l’école.',
    },
  },
  applyChoice: {
    title: {
      job: 'Ta candidature',
      initiative: 'Ta candidature spontanée',
    },
    back: {
      job: 'Retour au poste',
      initiative: 'Retour à l’école',
    },
    question: 'Comment veux-tu postuler ?',
    profile: {
      title: 'Postuler avec un profil',
      recommended: 'Recommandé',
      text: 'Crée ton profil gratuit en une minute. Ce qu’il t’apporte :',
      signup: 'S’inscrire gratuitement et postuler',
      hasAccount: 'Déjà un compte ?',
      login: 'Se connecter et continuer',
    },
    guest: {
      title: 'Postuler en tant qu’invité·e',
      text: {
        job: 'Sans compte, seulement pour ce poste. Tu télécharges tes documents directement.',
        initiative:
          'Sans compte, seulement pour cette école. Tu télécharges tes documents directement.',
      },
      upload: 'Télécharger ton CV et tes documents pour cette candidature',
      again: 'Pour d’autres candidatures, tu télécharges tout à nouveau',
      start: 'Continuer en tant qu’invité·e',
    },
  },
  applicationSent: {
    title: 'Candidature envoyée',
    titleInitiative: 'Candidature spontanée envoyée',
    textJobGuest:
      'Ta candidature pour le poste {{job}} est arrivée chez {{school}}. La confirmation est envoyée à {{email}}.',
    textJobMember:
      "Ta candidature pour le poste {{job}} est arrivée chez {{school}}. Tu en suis l'état sous «Mes candidatures».",
    textInitiativeGuest:
      'Ta candidature spontanée est arrivée chez {{school}}. La confirmation est envoyée à {{email}}.',
    textInitiativeMember:
      "Ta candidature spontanée est arrivée chez {{school}}. Tu en suis l'état sous «Mes candidatures».",
    close: 'Fermer',
    later: 'Non, merci',
    ok: 'Terminé',
    finishProfile: 'Terminer mon profil',
    moreJobs: "Voir d'autres postes",
    toApplications: 'Vers mes candidatures',
    offer: {
      title: 'Ton profil est presque prêt',
      text: 'Tes données sont reprises. Il ne reste que deux étapes, environ une minute.',
      stepsLabel: 'Créer le profil',
      stepTaken: 'Données et documents repris',
      stepEmail: "Confirmer l'adresse e-mail",
      stepPassword: 'Définir le mot de passe',
      done: 'fait',
      benefitsTitle: "Ce que t'apporte ton profil",
      benefitOneClick: 'Postuler en un clic, tes documents sont enregistrés',
      benefitStatus: "Suivre l'état de tes candidatures en direct",
      benefitChat:
        "Échanger avec l'école, avec notification push sur ton téléphone",
      benefitAlert: "Des postes adaptés grâce à l'alerte emploi",
    },
  },
  guestOnboarding: {
    title: 'Presque terminé, {{name}}',
    text: 'Ton adresse e-mail est confirmée. Il ne manque plus que ta désignation professionnelle.',
    later:
      'Tu pourras compléter tes disponibilités et ta photo plus tard dans ton profil.',
    submit: 'Créer le profil',
    qualificationMissing:
      'Merci de répondre à la question sur la qualification pour chaque désignation professionnelle.',
  },
  guestWelcome: {
    title: 'Bienvenue sur Bildigsnetz',
    text: 'Ton profil est prêt. Tu trouves ta candidature sous «Mes candidatures».',
    applications: 'Mes candidatures',
    jobs: 'Voir les postes ouverts',
    close: 'Fermer',
    hintTitle:
      'Pour que les écoles te trouvent : complète tes disponibilités et ta photo',
    hintText: 'Il ne manque plus que quelques informations.',
    hintAction: 'Compléter le profil',
  },
  initiativeApply: {
    cardTitle: 'Candidature spontanée',
    cardText:
      'Aucun poste ne te convient ? Envoie une candidature spontanée à {{school}}.',
    start: 'Envoyer une candidature spontanée',
    noPostingNeeded: 'aucun poste mis au concours nécessaire',
    intro:
      "Même sans poste publié, l'école se réjouit de faire ta connaissance.",
    missing: "Nous n'avons pas trouvé cette école.",
    allSchools: 'Toutes les écoles',
    fileMissing:
      "Un fichier n'a pas pu être lu. Merci de le téléverser à nouveau.",
    listHint: 'Candidature sans poste publié',
    error: {
      alreadyApplied:
        "Tu as déjà envoyé une candidature spontanée ici. Tant qu'elle est ouverte, une deuxième n'est pas possible.",
      disabled:
        'Les candidatures spontanées ne sont pas possibles pour le moment.',
      notPublished:
        "Cette école n'accepte pas de candidatures spontanées actuellement.",
      generic: "Une erreur s'est produite. Merci de réessayer.",
    },
  },
};
